const ProfileRoutes = {
  getMyProfile: "users/profile",
  updatePicture: "users/profile/picture",
  updateProfile: "users/update",
  changePassword: "users/changePassword",
};

export default ProfileRoutes